var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as mdb from 'mdb-ui-kit';
import 'mdb-ui-kit/css/mdb.min.css';
//-------------------------------------------------------------------
//how to install advanced components : 
// 1. in terminal scope up to CERBERUS
// 2. run ~ npm install git+https://oauth2:RdUyNS2pmiDpw-qzQQQA@git.mdbootstrap.com/mdb/standard/plugins/prd/component-name //e.g. organization-chart
//-------------------------------------------------------------------
import OrganizationChart from 'mdb-organization-chart';
import Treeview from 'mdb-treeview';
// mdb.OrganizationChart = OrganizationChart;
// mdb.Treeview = Treeview
// import 'mdb-organization-chart/css/mdb.organization-chart.min.css';
// import 'mdb-treeview/css/mdb.treeview.min.css';
window.mdb = __assign(__assign({}, mdb), { OrganizationChart: OrganizationChart, Treeview: Treeview });
//Taken from mdb-ui-kit/src/mdb/js/bootstrap/mdb-prefix/util/santizer.js
var DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': ['class', 'dir', 'id', 'lang', 'role', /^aria-[\w-]*$/i],
    a: ['target', 'href', 'title', 'rel'],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: ['src', 'srcset', 'alt', 'title', 'width', 'height'],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: [],
};
export var config = {
    renderer: mdb,
    description: 'This configuration file is designed to interface between cerberus styling and methods and frameworks: Bootstrap V5 and MDB V5',
    default: {
        implementation: [
            {
                name: "carousel",
                initialiser: "Carousel",
                eventSuffix: "mdb.carousel"
            },
            {
                name: "dropdown",
                initialiser: "Dropdown",
                eventSuffix: "mdb.dropdown"
            },
            {
                name: "tooltip",
                initialiser: "Tooltip",
                eventSuffix: "mdb.tooltip"
            },
            {
                name: "modal",
                initialiser: "Modal",
                eventSuffix: "bs.modal"
            },
            {
                name: "treeview",
                initialiser: "Treeview"
            },
            {
                name: "tab",
                initialiser: "Tab"
            },
            {
                name: "organizationChart",
                initialiser: "OrganizationChart"
            },
            {
                name: "popover",
                initialiser: "Popover",
                eventSuffix: "mdb.popover"
            },
            {
                name: "spinner",
                initialiser: null
            },
            {
                name: "progress",
                initialiser: null
            },
            {
                name: "sidenav",
                initialiser: "Sidenav",
                eventSuffix: "mdb.sidenav"
            },
            {
                name: "loading",
                initialiser: "Loading"
            },
            {
                name: "toast",
                initialiser: "Toast",
                eventSuffix: "mdb.Toast"
            },
            {
                name: "loading",
                initialiser: "Loading",
                //eventSuffix: "mdb.Loading"
            }
        ],
        // options : {
        //     tooltip : {
        //         animation : true,
        //         container : false,
        //         customClass : '',
        //         delay : 0,
        //         html : false,
        //         placement : 'top',
        //         selector : false,
        //         template : '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        //         title : '',
        //         trigger : 'hover focus',
        //         offset : '0',
        //         fallbackPlacement : 'flip',
        //         boundary : 'clippingParents',
        //         sanitize : true,
        //         whiteList : DefaultAllowlist,
        //         sanitizeFn : null,
        //         popperConfig : null,
        //     }
        // },
        // events : {
        //      tooltip : {
        //         show : null,
        //         shown : null,
        //         hide : null,
        //         hidden : null,
        //         inserted : null
        //     }
        // }
    }
};
